module.exports = __webpack_public_path__ + "media/images/proof_links/spotify-a3c4ba6efa4bc2aeb66bbfcc8b9190b6.svg";